export { default } from './List';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/List/index.js
// module id = 836
// module chunks = 0